/**
 * Created by Wang.chen on 2022/6/15.
 */
 import React, { useState, useEffect } from 'react'
 import { Modal, Input, Button, Table, message, Empty, Form } from 'antd';
 import store from '../../../../redux/store'
 import actionWays from '../../../../redux/actions'
 import '@wangeditor/editor/dist/css/style.css'
 import { Editor, Toolbar } from '@wangeditor/editor-for-react'
 import { getQiNiuToken, employmentInsertMessage, modifyMessage } from '../../../../utils/api'
 import From from '../../Form/index';
 import { useHistory } from 'react-router-dom';
 import { FILEACTIONURL } from '../../../../config/index';
 import moment from 'moment';
 const { TextArea } = Input;
 function TextBase(props) {
     // console.log(props)
     const history = useHistory()
     const [editor, setEditor] = useState(null) // 存储 editor 实例
     const [editorRenZhi, setEditorRenZhi] = useState(null) // 存储 editor 实例
     const [html, setHtml] = useState('') // 编辑器内容
     const [htmlRenZhi, setHtmlRenZhi] = useState('') // 编辑器内容
     const [form] = Form.useForm();
     const [token, setToken] = useState();
     const [contentArr, setContentArr] = useState();
     const [contentArrRenZhi, setContentArrRenZhi] = useState();
     const [title, setTitle] = useState();
     const [headline, setHeadline] = useState();
     const [cover, setCover] = useState();
     const [particularsVisible, handleParticularsVisible] = useState(false);
     const [particularsContent, setParticularsContent] = useState({});
     form.resetFields();
     useEffect(() => {
         setTimeout(() => {
             setHtml('<p>hello&nbsp;world</p>')
         }, 1500)
     }, [])
     const backFormData = store.getState().backFormData
     const toolbarConfig = {}
     const toolbarConfigRenZi = {}
 
     const editorConfigRenZi = {
         placeholder: '请输入岗位描述',
         onCreated(editorRenZhi) {
 
             if (props.isChange == false) {
                 editorRenZhi.setHtml('')
             } else {
                 if (backFormData[6].value == '') {
                     setEditorRenZhi(editorRenZhi);
                 } else {
                     editorRenZhi.setHtml(backFormData[6].value)
                 }
             }
 
         }, // 记录下 editor 实例，重要！
         onChange: (editorRenZhi) => {
             // editor 选区或者内容变化时，获取当前最新的的 content
             console.log('html', editorRenZhi.getHtml());
             setContentArrRenZhi(editorRenZhi.getHtml());
         },
         MENU_CONF: {
             // 配置字号
             // fontSize: [ 2,4,6,8,10 ],
 
             // 配置上传图片
             uploadImage: {
                 fieldName: 'file',
                //  server: 'https://up-z0.qiniup.com',
                 server: FILEACTIONURL,
                 meta: {
                    output: 'json',
                    scene: 'pubuilcHouse',
                    //  token: localStorage.getItem('qiniuToken'),
                 },
                 maxFileSize: 10 * 1024 * 1024,
                 customInsert(res, insertFn) {
                     // res 即服务端的返回结果
                     console.log('4444444444:', res);
                     // 从 res 中找到 url alt href ，然后插图图片
                    //  insertFn('https://qiniu.toseesoft.net/' + res?.key);
                    insertFn(res?.src);
                 },
             },
             // 配置上传视频
             uploadVideo: {
                 fieldName: 'file',
                //  server: 'https://up-z0.qiniup.com',
                 server: FILEACTIONURL,
                 meta: {
                    output: 'json',
                    scene: 'pubuilcHouse',
                    //  token: localStorage.getItem('qiniuToken'),
                 },
                 maxFileSize: 10 * 1024 * 1024,
                 customInsert(res, insertFn) {
                     // res 即服务端的返回结果
                     console.log('4444444444:', res);
                     // 从 res 中找到 url alt href ，然后插图图片
                    //  insertFn('https://qiniu.toseesoft.net/' + res?.key);
                    insertFn(res?.src);
                 },
             }
             // 继续其他菜单配置
         },
     };
     const editorConfig = {
         placeholder: '请输入任职要求',
         onCreated(editor) {
 
             if (props.isChange == false) {
                 editor.setHtml('')
             } else {
                 if (backFormData[7].value == '') {
                     setEditor(editor);
                 } else {
                     editor.setHtml(backFormData[7].value)
                 }
             }
 
         }, // 记录下 editor 实例，重要！
         onChange: (editor) => {
             // editor 选区或者内容变化时，获取当前最新的的 content
             setContentArr(editor.getHtml());
         },
         MENU_CONF: {
             // 配置字号
             // fontSize: [ 2,4,6,8,10 ],
 
             // 配置上传图片
             uploadImage: {
                 fieldName: 'file',
                //  server: 'https://up-z0.qiniup.com',
                 server: FILEACTIONURL,
                 meta: {
                    output: 'json',
                    scene: 'pubuilcHouse',
                    //  token: localStorage.getItem('qiniuToken'),
                 },
                 maxFileSize: 10 * 1024 * 1024,
                 customInsert(res, insertFn) {
                     // res 即服务端的返回结果
                     // 从 res 中找到 url alt href ，然后插图图片
                    //  insertFn('https://qiniu.toseesoft.net/' + res?.key);
                    insertFn(res?.src);
                 },
             },
             // 配置上传视频
             uploadVideo: {
                 fieldName: 'file',
                //  server: 'https://up-z0.qiniup.com',
                 server: FILEACTIONURL,
                 meta: {
                    output: 'json',
                    scene: 'pubuilcHouse',
                    //  token: localStorage.getItem('qiniuToken'),
                 },
                 maxFileSize: 10 * 1024 * 1024,
                 customInsert(res, insertFn) {
                     // res 即服务端的返回结果
                     // 从 res 中找到 url alt href ，然后插图图片
                    //  insertFn('https://qiniu.toseesoft.net/' + res?.key);
                     insertFn(res?.src);
                 },
             }
             // 继续其他菜单配置
         },
     };
     // 及时销毁 editor ，重要！
     useEffect(async () => {
         const result = await getQiNiuToken();
         if (result) {
             localStorage.setItem('qiniuToken', result)
             setToken(result);
         }
         return () => {
             if (editor == null) return
             editor.destroy()
             setEditor(null)
         }
     }, [editor])
     // 及时销毁 editorRenZhi ，重要！
     useEffect(async () => {
         const result = await getQiNiuToken();
         if (result) {
             localStorage.setItem('qiniuToken', result)
             setToken(result);
         }
         return () => {
             if (editorRenZhi == null) return
             editorRenZhi.destroy()
             setEditorRenZhi(null)
         }
     }, [editorRenZhi])
 
     //发布
     const onSubmint = async (type) => {
         const info = store.getState()
         formBase = info.backFormData
         let opt = {}
         if (!!formBase) {
             opt.positionName = formBase[0].value
             opt.positionContext = contentArrRenZhi
             opt.wage = formBase[1].value
             opt.positionRequirements = contentArr
             opt.status = formBase[2].value
             opt.numbers = formBase[3].value
             opt.address = formBase[4].value
             opt.department = formBase[5].value
             if (!!props.isChange) {
                 opt.pid = props.isChange
             }
             opt.recordtime = moment(new Date()).format('YYYY/MM/DD')
             // 判断用户信息是否存在
             console.log(props.userLoginInfo);
 
             if (!props.userLoginInfo) {
                 message.error('请先登录')
                 history.push({ pathname: '/login' })
             } else {
                 opt.operator = props.userLoginInfo.username
             }
 
             if (type === '') {
                 //  setParticularsContent(opt)
             } else {
                 let num = 0
                 info.backFormData.map((i, n) => {
                     if (i.value === '') {
                         num++
                     }
                 })
                 if (num > 2) {
                     message.error('请输入完整')
                 } else {
                    console.log(opt);
                     if (!opt.positionName  || !opt.wage  || opt.status === '' || !opt.numbers || !opt.address || !opt.department) {
                         message.error('请输入完整')
                         return
                     }
                     if (contentArr === '<p><br></p>' || contentArrRenZhi === '<p><br></p>') {
                         message.error('请输入岗位描述及任职要求')
                     } else {
                         if (!props.isChange) {
                             let res = await employmentInsertMessage(opt)
                             if (res.code === 0) {
                                 props.handleConstructionVisible(false)
                                 window.location.reload()
                             }
                         } else {
 
                             let res = await modifyMessage(opt)
                             if (res.code === 0) {
                                 props.handleConstructionVisible(false)
                                 window.location.reload()
                             }
                         }
 
                     }
                 }
             }
         } else {
             message.error('请输入完整')
         }
 
     }
     //动态form表单
     let formBase = {}
     if (backFormData == '') {
         formBase = {
             formList: [{
                 name: 'positionName',
                 label: '招聘职位',
                 type: 'Input',
                 baseInfo: [''],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请填写完整' }]
             }, {
                 name: 'wage',
                 label: '薪资区间',
                 type: 'Input',
                 baseInfo: [''],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请填写完整' }]
             }, {
                 name: 'status',
                 label: '岗位状态',
                 type: 'Select',
                 baseInfo: ['正常', '急招'],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请填写完整' }]
             }, {
                 name: 'numbers',
                 label: '招聘人数',
                 type: 'Input',
                 baseInfo: [''],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请选择' }]
             }, {
                 name: 'address',
                 label: '工作地点',
                 type: 'Input',
                 baseInfo: [''],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请填写完整' }]
             }, {
                 name: 'department',
                 label: '部门',
                 type: 'Input',
                 baseInfo: [''],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请填写完整' }]
             },
             {
                 name: 'positionContext',
                 label: '岗位描述',
                 type: 'Input',
                 baseInfo: [''],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请填写完整' }]
             },
             {
                 name: 'positionRequirements',
                 label: '任职要求',
                 type: 'Input',
                 baseInfo: [''],
                 render: '',
                 value: '',
                 rules: [{ required: true, message: '请填写完整' }]
             }
             ]
         }
     } else {
         formBase.formList = backFormData
     }
     
     // //更新表单数据数据
     // handleFormData = async (value) => {
     //     console.log(value)
     //     formBase = value
     //     console.log(formBase)
     // };
     // handleFormData()
     return (
         <div >
             <Modal
                 className='changeNew'
                 title={props.isChange?'编辑招聘':'新建招聘'}
                 centered
                 visible={props.constructionVisible}
                 onCancel={() => props.handleConstructionVisible(false)}
                 width={900}
                 height={400}
                 footer={[
                     // <Button onClick={() => onSubmint('')}>
                     //     预览
                     // </Button>,
                     <Button onClick={() => onSubmint(0)} style={{ background: '#0093D8', color: '#fff' }}>
                         发布
                     </Button>,
                     // <Button onClick={() => onSubmint(2)} >
                     //     存草稿
                     // </Button>,
                     <Button onClick={() => {
                         props.handleConstructionVisible(false)
                     }}>
                         取消
 
                     </Button>
                 ]}
             >
                 <From hasTap={false} isChange={props.isChange} formBase={formBase} hasSearch={false} isFull={true} id={'recruit'} type={'新建'} />
                 <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
 
                     <Toolbar
                         editor={editorRenZhi}
                         defaultConfig={toolbarConfigRenZi}
                         mode="default"
                         style={{ borderBottom: '1px solid #ccc' }}
                     />
                     <Editor
                         defaultConfig={editorConfigRenZi}
                         //  value={html}
                         onCreated={setEditorRenZhi}
                         onChange={editor => setHtmlRenZhi(editor.getHtml())}
                         mode="default"
                         style={{ height: '300px', 'overflow-y': 'hidden' }}
                     />
                 </div>
                 <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
 
                     <Toolbar
                         editor={editor}
                         defaultConfig={toolbarConfig}
                         mode="default"
                         style={{ borderBottom: '1px solid #ccc' }}
                     />
                     <Editor
                         defaultConfig={editorConfig}
                         //  value={html}
                         onCreated={setEditor}
                         onChange={editor => setHtml(editor.getHtml())}
                         mode="default"
                         style={{ height: '300px', 'overflow-y': 'hidden' }}
                     />
                 </div>
             </Modal>
         </div>
     )
 
 }
 export default TextBase;
 